import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { CheckCircle2, AlertCircle } from "lucide-react";

export default function VerifyEmail() {
    const [params] = useSearchParams();
    const token = params.get("token");
    const [state, setState] = useState("loading");
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (!token) {
            setState("error");
            setMessage("Token mancante nel link.");
            return;
        }
        api
            .post("/auth/verify-email", { token })
            .then(() => {
                setState("success");
                setMessage("Il tuo account è stato verificato.");
            })
            .catch((err) => {
                setState("error");
                setMessage(formatApiErrorDetail(err.response?.data?.detail) || "Errore nella verifica.");
            });
    }, [token]);

    return (
        <div className="co-container py-20 max-w-md text-center" data-testid="verify-email-page">
            <span className="co-caption">Verifica Email</span>
            <h1 className="font-serif text-3xl mt-2 mb-8">Conferma account</h1>

            {state === "loading" && (
                <p className="text-[hsl(var(--muted-foreground))]">Verifica in corso…</p>
            )}
            {state === "success" && (
                <div className="space-y-6" data-testid="verify-success">
                    <CheckCircle2 className="w-14 h-14 text-[hsl(var(--primary))] mx-auto" strokeWidth={1.2} />
                    <p className="text-lg">{message}</p>
                    <Link to="/login" className="co-btn-primary inline-flex" data-testid="verify-goto-login">
                        Accedi ora
                    </Link>
                </div>
            )}
            {state === "error" && (
                <div className="space-y-6" data-testid="verify-error">
                    <AlertCircle className="w-14 h-14 text-[hsl(var(--destructive))] mx-auto" strokeWidth={1.2} />
                    <p className="text-lg">{message}</p>
                    <Link to="/" className="co-btn-ghost inline-flex">
                        Torna alla carta
                    </Link>
                </div>
            )}
        </div>
    );
}
